import api from './ApiServices'

export default class JobService {
  static async listTempJobs () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
            listTemporaryJobs {
                id
                state
                organization {
                  id
                  name
                }
                contactDetail {
                  address {
                    city
                  }
                }
                branch {
                  id
                  brand
                  subBrand
                  jobLocation {
                    hospitalName
                    branchName
                  }
                }
                company {
                  id
                  name
                }
                department {
                  id
                  departmentType {
                    name
                  }
                }
                specialization {
                  name
                }
                qualification {
                  id
                  name
                }
                ctcYearly
                perMonthSalary
                specialization {
                  name
                  description
                }
                shift
                jobDescription
                numberOfJobs
                startDate{
                  ts
                }
                endDate{
                  ts
                }
              }
        }
    }`
    )

    if (response.error !== null) return false
    else return response.data.withAuth.listTemporaryJobs
  }

  static async listTempJobsbyHospital (id) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
            listTemporaryJobs(
              hospital:"${id}"
            ) {
                id
                state
                organization {
                  id
                  name
                }
                contactDetail {
                  address {
                    city
                  }
                }
                branch {
                  id
                  brand
                  subBrand
                  jobLocation {
                    hospitalName
                    branchName
                  }
                }
                company {
                  id
                  name
                }
                department {
                  id
                  departmentType {
                    name
                  }
                }
                specialization {
                  name
                }
                qualification {
                  id
                  name
                }
                ctcYearly
                perMonthSalary
                specialization {
                  name
                  description
                }
                shift
                jobDescription
                numberOfJobs
                startDate{
                  ts
                }
                endDate{
                  ts
                }
              }
        }
    }`
    )

    if (response.error !== null) return false
    else return response.data.withAuth.listTemporaryJobs
  }

  static async listTempJobsbyProfession (id, hospitalID) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
            listTemporaryJobs(
              profession:"${id}"
              hospital:"${hospitalID}"
            ) {
                id
                state
                organization {
                  id
                  name
                }
                contactDetail {
                  address {
                    city
                  }
                }
                branch {
                  id
                  brand
                  subBrand
                  jobLocation {
                    hospitalName
                    branchName
                  }
                }
                company {
                  id
                  name
                }
                department {
                  id
                  departmentType {
                    name
                  }
                }
                specialization {
                  name
                }
                qualification {
                  id
                  name
                }
                ctcYearly
                perMonthSalary
                specialization {
                  name
                  description
                }
                shift
                jobDescription
                numberOfJobs
                startDate{
                  ts
                }
                endDate{
                  ts
                }
              }
        }
    }`
    )

    if (response.error !== null) return false
    else return response.data.withAuth.listTemporaryJobs
  }

  static async listMiniJobs (type) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listMiniJobs{
            id
            code
            department
            specialization
            shift
            start
            end
            applications
            filled
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobs
  }

  static async listMiniJobsHospitals (id) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listMiniJobs( 
            hospital:"${id}"
          ){
            id
            code
            department
            specialization
            shift
            start
            end
            applications
            filled
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobs
  }

  static async listMiniJobsProfessions (id, hospitalId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listMiniJobs(
            profession:"${id}"
            hospital:"${hospitalId}"
          ){
            id
            code
            department
            specialization
            shift
            start
            end
            applications
            filled
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobs
  }

  static async listApplications (type) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listMiniJobApplications(type:${type}){
          id
          status
          professional {
            id
            emails {
              isPrimary
              address
            }
            phoneNumbers {
              isPrimary
              number
            }
            name {
              full
            }
            address {
              state
              address
              country
              city
              country
              pin
            }
            specialization {
              name
              id
            }
            numExperience {
              id
              name
            }
            workCity {
              id
              name
            }
            qualification {
              id
              name
            }
            professionalType {
              id
              name
            }
            profile {
              dob
              gender
              pan
              aadhar
              social {
                facebook
                linkedin
              }
              covid
              jobHistory {
                hospital
                department
                specialisation
                start
                end
              }
              education {
                course
                specialisation
                name
                year
              }
              references {
                name
                hospital
                designation
                phone
                email
              }
            }
            languageKnown {
              id
              name
            }
            additionalTraining {
              id
              name
            }
            workedOn {
              id
              softwarename
            }
            professionalRegistration {
              number
              registrationType {
                id
                name
              }
            }
            avatar {
              location
              fileName
              uri
              bucket
              region
              mimeType
              secureUrl
              url
              isSecured
              cdnUrl
            }
            correspondenceAddress {
              address
              city
              state
              pin
              country
            }
            departments {
              id
              name
            }
          }
          job {
              id
              code
              department
              specialization
              shift
              start
              end
              applications
              filled
            }
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobApplications
  }

  static async openJobDetails (jobId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listNurseApplications(job: "${jobId}") {
            id
            state
            organization {
              id
              name
            }
            appliedAt {
              month
            }
            professional {
              id
              status
              name {
                salutation
                first
                full
              }
              phoneNumbers {
                number
              }
              emails {
                address
              }
              role {
                id
                name
              }
              qualification {
                name
                description
              }
            }
            rejectedAt {
              ts
            }
            rejectReason
            createdAt
            professional {
              id
              emails {
                isPrimary
                address
              }
              phoneNumbers {
                isPrimary
                number
              }
              name {
                full
              }
              address {
                state
                address
                country
                city
                country
                pin
              }
              specialization {
                name
                id
              }
              numExperience {
                id
                name
              }
              workCity {
                id
                name
              }
              qualification {
                id
                name
              }
              professionalType {
                id
                name
              }
              profile {
                dob
                gender
                pan
                aadhar
                social {
                  facebook
                  linkedin
                }
                covid
                jobHistory {
                  hospital
                  department
                  specialisation
                  start
                  end
                }
                education {
                  course
                  specialisation
                  name
                  year
                }
                references {
                  name
                  hospital
                  designation
                  phone
                  email
                }
              }
              languageKnown {
                id
                name
              }
              additionalTraining {
                id
                name
              }
              workedOn {
                id
                softwarename
              }
              professionalRegistration {
                number
                registrationType {
                  id
                  name
                }
              }
              avatar {
                location
                fileName
                uri
                bucket
                region
                mimeType
                secureUrl
                url
                isSecured
                cdnUrl
              }
              correspondenceAddress {
                address
                city
                state
                pin
                country
              }
              departments {
                id
                name
              }
            }
            job {
              id
              code
              state
              organization {
                id
                name
              }
              company {
                id
                name
              }
              department {
                id
                departmentType {
                  name
                }
              }
              qualification {
                id
                name
                profession{
                  name
                }
              }
              maxRate
              minRate
              specialization {
                name
                description
              }
              shift
              numberOfJobs
              numberOfDays
              jobDescription
              contactDetail {
                address {
                  city
                  state
                  pin
                }
              }
              branch {
                id
                brand
                subBrand
                jobLocation {
                  hospitalName
                  branchName
                }
              }
              numExperience {
                name
              }
              consequtiveTime {
                start {
                  year
                  month
                  date
                  hour
                  ts
                }
                end {
                  year
                  month
                  date
                  hour
                  ts
                }
              }
            }
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listNurseApplications
  }
  
  static async approveApplication (applicationId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `mutation{
        mutationWithAuth(token: "${accessToken}"){
          update{
            approveApplication(
              application: "${applicationId}"
            )
          }
        }
      }`)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.approveApplication
  }

  static async shortList (applicationId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `mutation{
        mutationWithAuth(token: "${accessToken}"){
          update{
            shortlistApplication(
              application: "${applicationId}"
            )
          }
        }
      }`)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.shortlistApplication
  }

  static async listBranches () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listBranches {
            id
            subBrand
            organization {
              id
              name
            }
            company {
              id
              name
            }
            jobLocation {
              hospitalName
              branchName
            }
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listBranches
  }

  static async listProfessions () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listProfessionalType {
            id
            name
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listProfessionalType
  }
  
  static async getJobsByHospital (type, hospitalID) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listMiniJobApplications(
            type:${type}
            hospital:"${hospitalID}"
          ){
            id
            status
            professional {
              id
              emails {
                isPrimary
                address
              }
              phoneNumbers {
                isPrimary
                number
              }
              name {
                full
              }
              address {
                state
                address
                country
                city
                country
                pin
              }
              specialization {
                name
                id
              }
              numExperience {
                id
                name
              }
              workCity {
                id
                name
              }
              qualification {
                id
                name
              }
              professionalType {
                id
                name
              }
              profile {
                dob
                gender
                pan
                aadhar
                social {
                  facebook
                  linkedin
                }
                covid
                jobHistory {
                  hospital
                  department
                  specialisation
                  start
                  end
                }
                education {
                  course
                  specialisation
                  name
                  year
                }
                references {
                  name
                  hospital
                  designation
                  phone
                  email
                }
              }
              languageKnown {
                id
                name
              }
              additionalTraining {
                id
                name
              }
              workedOn {
                id
                softwarename
              }
              professionalRegistration {
                number
                registrationType {
                  id
                  name
                }
              }
              avatar {
                location
                fileName
                uri
                bucket
                region
                mimeType
                secureUrl
                url
                isSecured
                cdnUrl
              }
              correspondenceAddress {
                address
                city
                state
                pin
                country
              }
              departments {
                id
                name
              }
            }
            job {
                id
                code
                department
                specialization
                shift
                start
                end
                applications
                filled
              }
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobApplications
  }

  static async getJobsByProfessions (type, professionId, hospitalID) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
        withAuth(token: "${accessToken}") {
          listMiniJobApplications(
            type:${type}
            profession:"${professionId}"
            hospital:"${hospitalID}"
          ){
            id
            status
            professional {
              id
              emails {
                isPrimary
                address
              }
              phoneNumbers {
                isPrimary
                number
              }
              name {
                full
              }
              address {
                state
                address
                country
                city
                country
                pin
              }
              specialization {
                name
                id
              }
              numExperience {
                id
                name
              }
              workCity {
                id
                name
              }
              qualification {
                id
                name
              }
              professionalType {
                id
                name
              }
              profile {
                dob
                gender
                pan
                aadhar
                social {
                  facebook
                  linkedin
                }
                covid
                jobHistory {
                  hospital
                  department
                  specialisation
                  start
                  end
                }
                education {
                  course
                  specialisation
                  name
                  year
                }
                references {
                  name
                  hospital
                  designation
                  phone
                  email
                }
              }
              languageKnown {
                id
                name
              }
              additionalTraining {
                id
                name
              }
              workedOn {
                id
                softwarename
              }
              professionalRegistration {
                number
                registrationType {
                  id
                  name
                }
              }
              avatar {
                location
                fileName
                uri
                bucket
                region
                mimeType
                secureUrl
                url
                isSecured
                cdnUrl
              }
              correspondenceAddress {
                address
                city
                state
                pin
                country
              }
              departments {
                id
                name
              }
            }
            job {
                id
                code
                department
                specialization
                shift
                start
                end
                applications
                filled
              }
          }
        }
    }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobApplications
  }

  static async getJobById (id) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `{
        withAuth(token: "${accessToken}") {
          getJob(id: "${id}") {
            id
            state
            code
            jobDescription
            numberOfJobs
            numberOfDays
            organization {
              id
              name
              companyType {
                id
                name
              }
            }
            branch{
              jobLocation {
                hospitalName
                branchName
              }
            }
            department {
              id
              departmentType {
                name
              }
              branch {
                company {
                  id
                  name
                }
                brand
                subBrand
                jobLocation {
                  hospitalName
                  branchName
                }
              }
            }
            qualification {
              id
              name
              description
              profession {
                id
                name
              }
            }
            qualification {
              id
              name
              description
            }
            numExperience {
              id
              name
            }
            specialization {
              id
              name
            }
            minRate
            maxRate
            shift
            shiftLogs {
              startTime {
                ts
              }
              endTime {
                ts
              }
            }
            candidateType{
              name
            }
            contactDetail {
              address {
                address
                city
                state
              }
              email
              phone
            }
            consequtiveTime {
              start {
                ts
              }
              end {
                ts
              }
            }
            nonConsequtiveTime {
              start {
                ts
              }
              end {
                ts
              }
            }
          }
        }
      }
      `
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.getJob
  }

  static async keepMiniJob (jobID) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(`mutation{
      mutationWithAuth(token:"${accessToken}"){
        update{
          keepMiniJobOffers(job:"${jobID}")
        }
      }
    }`)
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.keepMiniJobOffers
  }

  static async revokeMiniJobOffers (jobID) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(`mutation{
      mutationWithAuth(token:"${accessToken}"){
        update{
          revokeMiniJobOffers(job:"${jobID}")
        }
      }
    }`)
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.revokeMiniJobOffers
  }

  static async cancelMiniJobApplication (jobApplicationID, reason, comment) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(`mutation{
      mutationWithAuth(token:"${accessToken}"){
        update{
          cancelMiniJobApplication(application:"${jobApplicationID}"
          reason: "${reason}"
          comment:"${comment}"
          )
        }
      }
    }`)
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.cancelMiniJobApplication
  }
  
  static async listMiniJobShiftLogs () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `{
        withAuth(token: "${accessToken}") {
          listMiniJobShiftLogs
           {
            id
            department
            code
            specialization
            shift
            user
            userId
            date
            in
            out
            log
            cost
          }
        }
      }
      `
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobShiftLogs
  }

  static async listMiniJobShiftLogsHospital (id) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `{
        withAuth(token: "${accessToken}") {
          listMiniJobShiftLogs(
            hospital:"${id}"
          )
           {
            id
            code
            department
            specialization
            shift
            user
            date
            in
            out
            log
            cost
          }
        }
      }
      `
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobShiftLogs
  }

  static async listMiniJobShiftLogsProfession (id, hospitalID) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `{
        withAuth(token: "${accessToken}") {
          listMiniJobShiftLogs(
            profession:"${id}"
            hospital:"${hospitalID}"
          )
           {
            id
            department
            code
            specialization
            shift
            user
            date
            in
            out
            log
            cost
          }
        }
      }
      `
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listMiniJobShiftLogs
  }

  static async approveMiniJobShiftLog (id, logId, comment, rating) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(`mutation{
      mutationWithAuth(token:"${accessToken}"){
        update {
          approveMiniJobShiftLog(
            job:"${id}"
            log:"${logId}"
            rating:${rating}
            comment:"${comment}"
          )
        }
      }
    }`)
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.approveMiniJobShiftLog
  }

  static async cancelMiniJobShiftLog (id, logId, comment) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(`mutation{
      mutationWithAuth(token:"${accessToken}"){
        update {
          cancelMiniJobShiftLog(
            comment:"${comment}"
            job:"${id}"
            log:"${logId}"
          )
        }
      }
    }`)
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.mutationWithAuth.update.cancelMiniJobShiftLog
  }

  static async getApplicationDetails (id) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `{
        withAuth(token: "${accessToken}") {
          getApplication(id:"${id}"){
            state
          }
        }
      }`
    )
    // console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.getApplication
  }

  static async timeapprovalreports () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `{
        withAuth(token: "${accessToken}") {
            listShiftLogs{
              hospital,
              location,
              profession,
              department,
              user,
              date,
              inTime,
              outTime,
              checkinTime,
              checkoutTime,
              cost,
              shift,
              status
            }
        }
      }
      `
    )
    console.log(response)
    if (response.error !== null) return false
    else return response.data.withAuth.listShiftLogs
  }
}
